// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PacksResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response for both the staff CRUD list and (via A3) the franqueado active-only
 * public catalog. Shape: { rows: AiCredits_PackRow[] }.
 */
import type { AiCredits_PackRow } from './AiCredits_PackRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_PacksResponseDados {
rows: AiCredits_PackRow[]
}

export type AiCredits_PacksResponse = ApiResponse<AiCredits_PacksResponseDados>;

registerResponseContract('AiCredits_PacksResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:               { type: 'number',  required: true },
      name:             { type: 'string',  required: true },
      credits:          { type: 'number',  required: true },
      price_cents:      { type: 'number',  required: false },
      currency:         { type: 'string',  required: false },
      provider_code:    { type: 'string',  required: false },
      countries:        { type: 'array',   required: false },
      active:           { type: 'number',  required: true },
      sort_order:       { type: 'number',  required: true },
      created_at:       { type: 'string',  required: false },
      updated_at:       { type: 'string',  required: false },
      purchase_enabled: { type: 'boolean', required: false },
    },
  },
})
